/* eslint-disable react/prop-types */
import React from "react";
import { X, FileText } from "lucide-react";

const NoteModal = ({ selectedPayment, showNoteModal, setShowNoteModal }) => {
  return (
    showNoteModal &&
    selectedPayment && (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
          <div className="p-6 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
            <h3 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
              <FileText size={18} className="text-primary" /> Invoice Notes
            </h3>
            <button onClick={() => setShowNoteModal(false)}>
              <X size={20} className="text-gray-400 dark:text-dark-muted" />
            </button>
          </div>
          <div className="p-6">
            <div className="bg-accent/30 dark:bg-gray-900/50 p-4 rounded-xl border border-gray-100 dark:border-dark-border">
              <p className="text-xs font-bold text-gray-400 dark:text-dark-muted uppercase mb-2">
                Client: <span className="text-text dark:text-dark-text normal-case font-medium">{selectedPayment.name}</span>
              </p>
              <div className="h-px bg-gray-100 dark:bg-gray-800 my-3"></div>
              <p className="text-sm text-text dark:text-dark-text leading-relaxed whitespace-pre-wrap font-medium">
                {selectedPayment.description || "No notes provided."}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default NoteModal;
